import React from 'react'

import { Testimonial } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { AvatarImage, CompanyName, CustomerName, Icon, ItemWrapper, Text } from './TestimonialItem.styled'

export const TestimonialItem = ({ item }: { item: Testimonial }): JSX.Element => {
    return (
        <ItemWrapper>
            <Text>{item.text}</Text>
            <Grid container alignItems="center">
                <Grid item spacingRight={2}>
                    {item.customerAvatar && <AvatarImage image={item.customerAvatar} />}
                </Grid>
                <Grid item xs>
                    <CustomerName>{item.customerName}</CustomerName>
                    <CompanyName>{item.customerCompanyName}</CompanyName>
                </Grid>
            </Grid>
            <Icon />
        </ItemWrapper>
    )
}
